import React, { useState } from "react";
import "./CTASection.css";
import PopupModal from "../../../components/Modal/PopupModal";

const CTASection = () => {
  const [getPopUpShow, setPopUpShow] = useState(false);

  const onhide = () => {
    setPopUpShow(false);
  };

  const handelclick = () => {
    setPopUpShow(true);
  };

  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2 className="cta-title">Ready to Lead the Change?</h2>

        <p className="cta-text">
          Digital transformation isn't just about efficiency—it's about building
          a more agile, resilient, and competitive business. See how leading
          organizations are leveraging our technology to gain a strategic
          advantage.
        </p>

        <p className="cta-text">
          Our experts are ready to share industry best practices that can
          elevate your operations and drive efficiency. Let us help you navigate
          your digital transformation journey.
        </p>
      </div>
      <div className="cta-button-wrapper">
        <button className="main-btn me-5" onClick={handelclick}>
          Book a Demo
        </button>
      </div>
      <PopupModal show={getPopUpShow} onHide={onhide} />
    </section>
  );
};

export default CTASection;
